import { call, put, takeEvery } from 'redux-saga/effects'
import * as api from './api'
import {
  indicatorRequest,
  indicatorResponse
} from './actions'

export function * handleIndicatorRequest(action) {
  const { key, type, value } = action.payload

  yield put(indicatorResponse({ key }))

  try {
    const data = yield call(api.fetchIndicator, { type, value })
    yield put(indicatorResponse({ data, key }))
  } catch (error) {
    yield put(indicatorResponse({ error, key }))
  }
}

export default function * saga() {
  yield takeEvery(indicatorRequest, handleIndicatorRequest)
}
